import { deleteData, getData, getDataforUrl, postFormData, patchFormData } from "./index";

export const companyList = async (payload) => {
  return getData("admin/getCompany", payload).then((data) => {
    return data;
  });
};
export const getCompanyDetail = async (payload) => {
  return getData("admin/getCompanyDetail", payload).then((data) => {
    return data;
  });
};
export const addCompany = async (payload) => {
  return postFormData("admin/updateCompany", payload).then((data) => {
    return data;
  });
};
export const removeCompany = async (payload) => {
  return deleteData("admin/removeCompany", payload).then((data) => {
    return data;
  });
};

export const changeCompanyStatus = async (payload) => {
  return patchFormData("admin/changeCompanyStatus", payload).then((data) => {
    return data;
  });
};

export const emailTemplateList = async (payload) => {
  return getData("admin/email-templates", payload).then((data) => {
    return data;
  });
};

export const updateEmailTemplate = async (payload) => {
  return postFormData("admin/updateEmailTemplate", payload).then((data) => {
    return data;
  });
};

export const getEmailTemplateDetail = async (payload) => {
  return getData("admin/getEmailTemplateDetail", payload).then((data) => {
    return data;
  });
};

export const emailTemplateMasterList = async (payload) => {
  return getData("admin/master-email-templates", payload).then((data) => {
    return data;
  });
};

export const companySetting = async (payload) => {
  return getData("admin/fetchSettings", payload).then((data) => {
    return data;
  });
};